/**
 * The subset of a team's outbound-label settings needed to decide personalized
 * inserts access. Kept structurally minimal so both the plain model type and the
 * Mongoose-hydrated settings type satisfy it.
 */
export interface PersonalizedSlipsAccessSettings {
  personalizedSlipsMonetization?: { enabled?: boolean | null } | null;
  personalizedSlipsTermsAcceptedAt?: Date | null;
}

/**
 * Whether a merchant may access personalized inserts. Monetization is the gate:
 * Redo must have enabled monetization in admin AND the merchant must have
 * accepted the payment terms in-product.
 */
export function personalizedSlipsAccessible(
  outboundLabels: PersonalizedSlipsAccessSettings | undefined | null,
): boolean {
  return (
    (outboundLabels?.personalizedSlipsMonetization?.enabled ?? false) &&
    outboundLabels?.personalizedSlipsTermsAcceptedAt != null
  );
}
